import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import { useNavigate, Outlet } from 'react-router-dom'
import type { State } from 'types/redux'
import {
  ANALYTICS_LIMITED,
  ANALYTICS_UNLIMITED,
  IS_ARTIST,
} from '@disco/constants/FeatureTypes'
import type { featureData } from '@disco/state-management/selectors/business'
import {
  useFeatureData,
  useFeatureEnabled,
} from '@disco/state-management/selectors/business'
import InsightsTeam from './InsightsTeam'

const InsightsTeamContainer = (): React.ReactNode => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { isFeatureEnabled, isTrial }: featureData =
    useFeatureData(ANALYTICS_UNLIMITED)
  const { isFeatureEnabled: isFeatureLimited }: featureData =
    useFeatureData(ANALYTICS_LIMITED)
  const isArtist: boolean = useFeatureEnabled(IS_ARTIST)
  useEffect(() => {
    if (isArtist) {
      navigate('/insights')
    }
  }, [isArtist, navigate])
  const stats: State['stats'] = useSelector(state => state.stats)
  return (
    <>
      <InsightsTeam
        state={stats}
        {...{
          isFeatureEnabled,
          isFeatureLimited,
          isTrial,
        }}
      />
      <Outlet />
    </>
  )
}

export default InsightsTeamContainer
